import axios from 'axios';
import axiosConfigurer from './axiosConfigurer';
axiosConfigurer(axios);

export default axios;
